import { useContext } from "react";
import { Box, Typography } from "@mui/material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { INTAKE_COLORS, INTAKE_FONT } from "../../theme/intakeTokens";
import { INTAKE_PROFILE_ROW_PX, APP_HEADER_HEIGHT } from "../layout/layoutConstants";
import { SidebarContext } from "../layout/DashboardLayout";

export const GATE_BREADCRUMB_LABELS = ["Gate-0", "Gate-1", "Gate-2", "Gate-3", "Gate-4"];

export function gateBreadcrumbLabel(activeGate = 0) {
  return GATE_BREADCRUMB_LABELS[activeGate] ?? GATE_BREADCRUMB_LABELS[0];
}

export default function IntakeBreadcrumb({
  activeGate = 0,
  label,
  hideTrail = false,
  rightContent = null,
  sticky = false,
}) {
  const sidebarContext = useContext(SidebarContext);
  const sidebarWidth = sidebarContext?.sidebarWidth || 0;
  const trailLabel = label ?? gateBreadcrumbLabel(activeGate);
  const showTrail = !hideTrail && Boolean(trailLabel);

  const barSx = {
    flexShrink: 0,
    bgcolor: INTAKE_COLORS.surface,
    borderBottom: `1px solid ${INTAKE_COLORS.border}`,
    pl: INTAKE_PROFILE_ROW_PX,
    pr: { xs: 2, md: 2.5 },
    height: APP_HEADER_HEIGHT,
    minHeight: APP_HEADER_HEIGHT,
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    fontFamily: INTAKE_FONT,
    ...(sticky
      ? {
          position: "fixed",
          top: APP_HEADER_HEIGHT,
          left: sidebarWidth,
          right: 0,
          width: sidebarWidth ? `calc(100% - ${sidebarWidth}px)` : "100%",
          zIndex: 1100,
          transition: "left 0.2s ease, width 0.2s ease",
        }
      : {}),
  };

  return (
    <>
      <Box sx={barSx}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            minWidth: 0,
            flex: rightContent ? "1 1 auto" : undefined,
            height: "100%",
          }}
        >
          <Box
            component="span"
            aria-label="Home"
            aria-disabled="true"
            sx={{
              border: 0,
              bgcolor: "transparent",
              p: 0,
              m: 0,
              width: 24,
              height: 24,
              flexShrink: 0,
              cursor: "not-allowed",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#BBBBBB",
              lineHeight: 0,
              textDecoration: "none",
            }}
          >
            <HomeOutlinedIcon sx={{ fontSize: 24 }} />
          </Box>
          {showTrail ? (
            <>
              <ChevronRightIcon sx={{ fontSize: 16, color: INTAKE_COLORS.textMuted, flexShrink: 0 }} />
              <Typography
                component="span"
                sx={{
                  m: 0,
                  fontFamily: INTAKE_FONT,
                  fontSize: 13,
                  fontWeight: 500,
                  lineHeight: "20px",
                  color: INTAKE_COLORS.textSecondary,
                  whiteSpace: "nowrap",
                }}
              >
                {trailLabel}
              </Typography>
            </>
          ) : null}
        </Box>
        {rightContent ? (
          <Box
            sx={{
              ml: "auto",
              pl: 1,
              flexShrink: 0,
              display: "flex",
              alignItems: "center",
              height: "100%",
            }}
          >
            {rightContent}
          </Box>
        ) : null}
      </Box>
      {/* Keeps page content below the fixed bar so layout doesn't jump */}
      {sticky ? <Box sx={{ height: APP_HEADER_HEIGHT, flexShrink: 0 }} aria-hidden /> : null}
    </>
  );
}
